module.exports = __webpack_public_path__ + "img/hero-extra.74d91d21.png";